import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { RecuperarComponent } from './pages/recuperar/recuperar.component';
import { CommonModule } from '@angular/common';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor'; // ajusta el path si tu carpeta es diferente
import { SafetyControlOfflineCacheInterceptor } from './interceptors/safety-control-offline-cache.interceptor';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AlertComponent } from './shared/components/alert/alert.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { SidebarDashboardMenuDirective } from './shared/components/sidebar/sidebar-dashboard-menu.directive';
import { TopBarComponent } from './shared/components/top-bar/top-bar.component';
// import { DigitalCardLauncherComponent } from './shared/components/digital-card/digital-card-launcher.component';
import { CopilotChatComponent } from './shared/components/copilot-chat/copilot-chat.component';
import { AvatarAssistantComponent } from './shared/components/avatar-assistant/avatar-assistant.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button'; // también requerido
import { SafeUrlPipe } from './shared/pipes/safe-url.pipe';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NoAutorizadoComponent } from './pages/shared/no-autorizado/no-autorizado.component';
import { MantenimientoComponent } from './pages/shared/mantenimiento/mantenimiento.component';
import { UpdateContactInfoComponent } from './pages/public/update-contact-info/update-contact-info.component';
///project-control/matriz-iperc/kyara-ai
import { TimeAgoPipe } from './utils/time_ago.pipe';
import { PublicProspectoFormComponent } from './pages/recursos-humanos/contratacion/prospectos-management/public-forms/public-prospecto-form.component';
import { MatIconModule } from '@angular/material/icon';
import { SharedIframeDocumentosModule } from 'app/shared/components/modals/iframe-documentos/iframe-documentos-shared.module';
import { SharedMeetingModalModule } from 'app/shared/components/modals/meeting/meeting-modal-shared.module';
import { registerOperationalPermissionPages } from './core/config/permisos-paginas-operativas';

import { CompanySelectorComponent } from './shared/components/company-selector/company-selector.component';
registerOperationalPermissionPages();

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    RecuperarComponent,
    AlertComponent,
    SidebarComponent,
    SidebarDashboardMenuDirective,
    TopBarComponent,
    // DigitalCardLauncherComponent,
    CopilotChatComponent,
    AvatarAssistantComponent,
    MantenimientoComponent,
    PublicProspectoFormComponent,
    UpdateContactInfoComponent,
  ],
  imports: [
    CompanySelectorComponent,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatButtonModule,
    SafeUrlPipe,
    MatSelectModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    NoAutorizadoComponent,
    TimeAgoPipe,
    MatIconModule,
    SharedIframeDocumentosModule,
    SharedMeetingModalModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SafetyControlOfflineCacheInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  exports: [AlertComponent],
})
export class AppModule {}
